import * as styles from "./Modal.css";

import { useAtomValue } from "jotai";

import { isVisibleAtom } from "../../stores";
import { ContactDetail } from "../ContactDetail";
import { ContactList } from "../ContactList";
import { Overlay } from "../Overlay";
import { Sidebar } from "../Sidebar";

export function Modal({ contained }: { readonly contained?: boolean }) {
  const isVisible = useAtomValue(isVisibleAtom);

  return (
    <Overlay background="blur" isVisible={isVisible} contained={contained}>
      {isVisible && (
        <div className={styles.modal({ contained })}>
          <Sidebar />
          <ContactList />
          <ContactDetail />
        </div>
      )}
    </Overlay>
  );
}
